  // Tabla presión-temperatura de saturación.
  //
  // pressurePsig: presión manométrica en psig.
  // tempC: temperatura de saturación en °C.
  //
  // Los valores de R134a provienen de la tabla
  // presión-temperatura proporcionada para el proyecto.

  export const REFRIGERANT_PT_TABLES = {
    R134A: [
      { tempC: 0, pressurePsig: 27.8 },
      { tempC: 1, pressurePsig: 29.3 },
      { tempC: 2, pressurePsig: 30.9 },
      { tempC: 3, pressurePsig: 32.6 },
      { tempC: 4, pressurePsig: 34.3 },
      { tempC: 5, pressurePsig: 36.0 },
      { tempC: 6, pressurePsig: 37.8 },
      { tempC: 7, pressurePsig: 39.6 },
      { tempC: 8, pressurePsig: 41.5 },
      { tempC: 9, pressurePsig: 43.4 },
      { tempC: 10, pressurePsig: 45.4 },
      { tempC: 11, pressurePsig: 47.5 },
      { tempC: 12, pressurePsig: 49.5 },
      { tempC: 13, pressurePsig: 51.7 },
      { tempC: 14, pressurePsig: 53.9 },
      { tempC: 15, pressurePsig: 56.1 },
      { tempC: 16, pressurePsig: 58.4 },
      { tempC: 17, pressurePsig: 60.8 },
      { tempC: 18, pressurePsig: 63.2 },
      { tempC: 19, pressurePsig: 65.7 },
      { tempC: 20, pressurePsig: 68.2 },
      { tempC: 21, pressurePsig: 70.8 },
      { tempC: 22, pressurePsig: 73.5 },
      { tempC: 23, pressurePsig: 76.2 },
      { tempC: 24, pressurePsig: 78.9 },
      { tempC: 25, pressurePsig: 81.8 },
      { tempC: 26, pressurePsig: 84.7 },
      { tempC: 27, pressurePsig: 87.7 },
      { tempC: 28, pressurePsig: 90.7 },
      { tempC: 29, pressurePsig: 93.8 },
      { tempC: 30, pressurePsig: 97.0 },
      { tempC: 31, pressurePsig: 100.2 },
      { tempC: 32, pressurePsig: 103.6 },
      { tempC: 33, pressurePsig: 106.9 },
      { tempC: 34, pressurePsig: 110.4 },
      { tempC: 35, pressurePsig: 113.9 },
      { tempC: 36, pressurePsig: 117.5 },
      { tempC: 37, pressurePsig: 121.2 },
      { tempC: 38, pressurePsig: 125.0 },
      { tempC: 39, pressurePsig: 128.8 },
      { tempC: 40, pressurePsig: 132.7 },
      { tempC: 41, pressurePsig: 136.7 },
      { tempC: 42, pressurePsig: 140.8 },
      { tempC: 43, pressurePsig: 144.9 },
      { tempC: 44, pressurePsig: 149.2 },
      { tempC: 45, pressurePsig: 153.5 },
      { tempC: 46, pressurePsig: 157.9 },
      { tempC: 47, pressurePsig: 162.4 },
      { tempC: 48, pressurePsig: 167.0 },
      { tempC: 49, pressurePsig: 171.7 },
      { tempC: 50, pressurePsig: 176.4 },
      { tempC: 52, pressurePsig: 186.2 },
      { tempC: 54, pressurePsig: 196.4 },
      { tempC: 56, pressurePsig: 206.9 },
      { tempC: 58, pressurePsig: 217.8 },
      { tempC: 60, pressurePsig: 229.2 },
      { tempC: 62, pressurePsig: 240.9 },
      { tempC: 64, pressurePsig: 253.1 },
      { tempC: 66, pressurePsig: 265.7 },
      { tempC: 68, pressurePsig: 278.7 },
      { tempC: 70, pressurePsig: 292.2 },
      { tempC: 72, pressurePsig: 306.2 },
      { tempC: 74, pressurePsig: 320.7 },
    ],

    // R507A
    // Fuente original: BITZER, presión en bar absolutos.
    // Los valores de presión fueron convertidos a psig
    // para trabajar con las señales del EMS.
    R507A: [
      { tempC: -21.6, pressurePsig: 28.8 },
      { tempC: -17.4, pressurePsig: 36.1 },
      { tempC: -13.6, pressurePsig: 43.3 },
      { tempC: -10.2, pressurePsig: 50.6 },
      { tempC: -7.1, pressurePsig: 57.8 },
      { tempC: -4.2, pressurePsig: 65.1 },
      { tempC: -1.5, pressurePsig: 72.3 },
      { tempC: 1.0, pressurePsig: 79.6 },
      { tempC: 3.4, pressurePsig: 86.8 },
      { tempC: 5.7, pressurePsig: 94.1 },
      { tempC: 7.9, pressurePsig: 101.3 },
      { tempC: 9.9, pressurePsig: 108.6 },
      { tempC: 11.9, pressurePsig: 115.8 },
      { tempC: 13.8, pressurePsig: 123.1 },
      { tempC: 15.6, pressurePsig: 130.3 },
      { tempC: 17.4, pressurePsig: 137.6 },
      { tempC: 19.1, pressurePsig: 144.8 },
      { tempC: 20.7, pressurePsig: 152.1 },
      { tempC: 22.3, pressurePsig: 159.3 },
      { tempC: 23.9, pressurePsig: 166.6 },
      { tempC: 25.3, pressurePsig: 173.9 },
      { tempC: 26.8, pressurePsig: 181.1 },
      { tempC: 28.2, pressurePsig: 188.4 },
      { tempC: 29.6, pressurePsig: 195.6 },
      { tempC: 30.9, pressurePsig: 202.9 },
      { tempC: 32.2, pressurePsig: 210.1 },
      { tempC: 33.5, pressurePsig: 217.4 },
      { tempC: 34.8, pressurePsig: 224.6 },
      { tempC: 36.0, pressurePsig: 231.9 },
      { tempC: 37.2, pressurePsig: 239.1 },
      { tempC: 38.3, pressurePsig: 246.4 },
      { tempC: 39.5, pressurePsig: 253.6 },
      { tempC: 40.6, pressurePsig: 260.9 },
      { tempC: 41.7, pressurePsig: 268.1 },
      { tempC: 42.8, pressurePsig: 275.4 },
      { tempC: 43.8, pressurePsig: 282.6 },
      { tempC: 44.8, pressurePsig: 289.9 },
      { tempC: 45.9, pressurePsig: 297.1 },
      { tempC: 46.9, pressurePsig: 304.4 },
      { tempC: 47.8, pressurePsig: 311.6 },
      { tempC: 48.8, pressurePsig: 318.9 },
      { tempC: 49.7, pressurePsig: 326.1 },
      { tempC: 50.7, pressurePsig: 333.4 },
      { tempC: 51.6, pressurePsig: 340.6 },
      { tempC: 52.5, pressurePsig: 347.9 },
      { tempC: 53.4, pressurePsig: 355.2 },
      { tempC: 54.2, pressurePsig: 362.4 },
      { tempC: 55.1, pressurePsig: 369.7 },
      { tempC: 55.9, pressurePsig: 376.9 },
      { tempC: 56.8, pressurePsig: 384.2 },
      { tempC: 57.6, pressurePsig: 391.4 },
      { tempC: 58.4, pressurePsig: 398.7 },
      { tempC: 59.2, pressurePsig: 405.9 },
      { tempC: 60.0, pressurePsig: 413.2 },
      { tempC: 60.8, pressurePsig: 420.4 },
    ],
  };

  